import { handleResponseOld, makePost } from './helpers';

/**
 * @category Item API
 * @see fetchSellerEndedCatalogsById
 */
type FetchSellerDetailsByIdsParams = {
    authToken: string;
    deployment: string;
    sellerIds: number[];
};

/**
 * fetches seller detail by given sellerId via Post request to Item API service
 * @function fetchSellerEndedCatalogsById
 * @category Item API
 * @param {FetchSellerEndedCatalogsByIdParams}
 * @see https://item-api-DEPLOYMENT.liveauctioneers.com/small/seller-detail
 * @see https://github.com/LIVEauctioneers/item-api/blob/master/src/inventory/routes/post-seller-detail.ts
 */
const fetchSellerDetailsByIds = ({ authToken, deployment, sellerIds }: FetchSellerDetailsByIdsParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({ authToken, deployment, path: '<ITEM-API>small/seller-detail' });
        request.send({ ids: sellerIds });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

export default {
    fetchSellerDetailsByIds,
};
